import { put, call, takeEvery } from 'redux-saga/effects';
import { replace, push } from 'connected-react-router';
import { get } from 'lodash/fp';
import {
  GROUPS_REQUEST,
  GROUP_REQUEST,
  CREATE_GROUP_REQUEST,
  UPDATE_GROUP_REQUEST,
  DELETE_GROUP_REQUEST,
} from './actionTypes';
import {
  groupsSuccess,
  groupsFailure,
  groupSuccess,
  groupFailure,
  createGroupSuccess,
  createGroupFailure,
  updateGroupSuccess,
  updateGroupFailure,
  deleteGroupSuccess,
  deleteGroupFailure,
} from './actions';
import GroupService from '../../services/GroupsService';

export function* getGroupsTask() {
  try {
    const list = yield call(GroupService.getGroups);
    yield put(groupsSuccess(list));
  } catch (error) {
    yield put(groupsFailure(error));
  }
}

export function* getGroupTask(action) {
  try {
    const { groupId, editGroup } = action.payload;
    const group = yield call(GroupService.getGroup, groupId);
    if (editGroup) {
      yield put(push(`/group/${group.id}`));
    }
    yield put(groupSuccess(group));
  } catch (error) {
    yield put(groupFailure(error));
  }
}

export function* createGroupTask(action) {
  try {
    const params = action.payload;
    const group = yield call(GroupService.createGroup, params);
    yield put(createGroupSuccess(group));
    yield put(replace(`/group/${group.id}`));
  } catch (error) {
    yield put(createGroupFailure(error));
  }
}

export function* updateGroupTask(action) {
  try {
    const { payload: group } = action;
    // Changed to this since a null or even empty value for route is taken by get/getOr even when a default value is given
    const route = get('route')(group) || '/groups';
    const updatedGroup = yield call(GroupService.updateGroup, group);
    yield put(updateGroupSuccess(updatedGroup));
    yield put(createGroupSuccess(group));
    yield put(replace(route));
  } catch (error) {
    yield put(updateGroupFailure(error));
  }
}

export function* deleteGroupTask(action) {
  try {
    const groupId = action.payload;
    yield call(GroupService.deleteGroup, groupId);
    yield put(deleteGroupSuccess(groupId));
  } catch (error) {
    yield put(deleteGroupFailure(error));
  }
}

export function* groupsSaga() {
  yield takeEvery(GROUPS_REQUEST, getGroupsTask);
  yield takeEvery(GROUP_REQUEST, getGroupTask);
  yield takeEvery(CREATE_GROUP_REQUEST, createGroupTask);
  yield takeEvery(UPDATE_GROUP_REQUEST, updateGroupTask);
  yield takeEvery(DELETE_GROUP_REQUEST, deleteGroupTask);
}
